import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { TranslatableText } from '@dreryk/react-common';
import {
   EventUpcomingIcon,
   IconFillColor,
   IconSize,
   IconWrapper,
   Link,
   StandardSpinner,
   StyledFlex,
   Tooltip,
   TooltipTrigger,
} from '@dreryk/react-components';

import { calendarTranslationKeys } from '../../../translations';

import { useCqrsGetAvailabilityConfigurationForPractitioner } from './MiniCalendarNextAvailableTimeSlot.hooks';

type MiniCalendarNextAvailableTimeSlotProps = {
   readonly onClick: VoidFunction;
   readonly noAvailableSlots: boolean;
   readonly loading: boolean;
   readonly practitionerId: PractitionerId;
};

const getTooltipMessage = (
   hadEverDoctorAvailabilityTimeSlots: boolean | undefined,
   noAvailableSlots: boolean
): TranslatableText | undefined => {
   if (noAvailableSlots) {
      return calendarTranslationKeys.noAvailableTimeSlots;
   }
   if (!hadEverDoctorAvailabilityTimeSlots) {
      return calendarTranslationKeys.addVisitDurationInSchedulePanel;
   }
   return undefined;
};

export const MiniCalendarNextAvailableTimeSlot = (props: MiniCalendarNextAvailableTimeSlotProps): JSX.Element => {
   const { data: hadEverDoctorAvailabilityTimeSlots } = useCqrsGetAvailabilityConfigurationForPractitioner(
      props.practitionerId
   );

   return (
      <Tooltip
         content={getTooltipMessage(hadEverDoctorAvailabilityTimeSlots, props.noAvailableSlots)}
         trigger={TooltipTrigger.HOVER}
         disabled={Boolean(hadEverDoctorAvailabilityTimeSlots && !props.noAvailableSlots)}
         testId='nextAvailableTimeSlot'
      >
         <StyledFlex gap='5px' alignItems='center'>
            <Link
               label={calendarTranslationKeys.nextAvailableTimeSlot}
               icon={
                  <IconWrapper size={IconSize.SMALL} testId='nextAvailableTimeSlot' fillColor={IconFillColor.INHERIT}>
                     <EventUpcomingIcon />
                  </IconWrapper>
               }
               testId={'nextAvailableTimeSlot'}
               disabled={props.noAvailableSlots || props.loading || !hadEverDoctorAvailabilityTimeSlots}
               onClick={props.onClick}
            />
            {props.loading ? <StandardSpinner /> : null}
         </StyledFlex>
      </Tooltip>
   );
};
